import styled from 'styled-components';
import { OutlinedInput } from '@mui/material';
import { Styling } from '../../../../constants';

const labelWidth = 70;
const labelRightMargin = Styling.DEFAULT_SPACING;
const valueRowHeight = 48;

export const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  margin: ${Styling.DEFAULT_SPACING}px 0 ${Styling.DEFAULT_SPACING_HALVED}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;

export const Label = styled.div`
  margin-right: ${labelRightMargin}px;
  text-align: center;
  width: ${labelWidth}px;
`;

export const Value = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const ValuesContainer = styled.div`
  min-height: ${valueRowHeight * 2}px;
  max-height: ${valueRowHeight * 2}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED + 2}px 0 ${labelWidth + labelRightMargin + Styling.DEFAULT_SPACING_DOUBLED}px;
  overflow: overlay;
`;
